export const localDebugEnabled = (hostname = window.location.hostname, profile = process.env.REACT_APP_ADENREL_PROFILE) =>
  profile !== 'alpha' && ['localhost', '127.0.0.1', '[::1]', '::1'].includes(String(hostname).toLowerCase());
